<div class="flex justify-between mb-4">
  <div class="text-xl text-gray-700 font-bold">Paciente</div>
  <div class="mr-8">
    @if (checkPermission('criar', 'legal')) {
      <button mat-raised-button class="btn-add mr-2" (click)="newClient()">
        Novo Paciente
      </button>
    }
  </div>
</div>
      <patient-main></patient-main>

